import React, {useEffect, useState} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useLocation, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import InputFile from '@app/components/input-file/InputFile';
import {Get, Put} from '@app/utils/httpProvider';
import {useQuery, useQueryClient, useMutation} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import {NIL as NIL_UUID} from 'uuid';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {
    messageError,
    messageToast,
    acceptImage,
    objectDataTypeCategory,
    styleSelectDefault,
    styleSelectError,
    status200,
    dataTypeCategory,
    objectDataTypeVideo,
    objectTypeQA,
    objectAnswerChoice,
    answerChoice,
    objectSentenceType,
    sentenceType,
    objectDeviceStatus,
    role,
    objectTrangThaiDeNghi,
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    objectLoai,
    objectLoaiXuLy,
    loaiNoiDungValue,
    objectLoaiNoiDung
} from '../../utils/define';
import {BaseGatewayImage, DISEASE_API} from '../../utils/apiUrl.js';
import {
    getInfomationAccountFromToken,
    isValidUrl,
    stripHtmlAndDollarSigns
} from '../../utils/helper';
import DatePicker from 'react-datepicker';
import {WithContext as ReactTags} from 'react-tag-input';

const schema = yup.object().shape({
    // loaiNoiDung: yup
    //     .object()
    //     .nullable()
    //     .required('Trường dữ liệu không được để trống')
});

// const DiseaseEdit = ({item, onSaved, onCancel}) => {
const DiseaseEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const diseaseId = paramUrl.get('id');

    // const inforAccount = getInfomationAccountFromToken();
    // let accountRoleManageDevice = false;

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleManageDevice =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    //     // accountRoleBooker =
    //     //     userRole.includes(role.Admin) || userRole.includes(role.Booker);
    // }

    // const inforAccount = getInfomationAccountFromToken();

    // const listDepartment = useQuery(['getAllDepartment', giamSatChinhSuaPhanMemId], () =>
    //     Get(DONVIDENGHI_API.GET_ALL, null, null)
    // );

    // const listAccount = useQuery(['getAllAccount'], () =>
    //     Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, {
    //         PageIndex: 1,
    //         PageSize: 5000
    //     })
    // );

    // const lstAccount =
    //     listAccount && listAccount.data && listAccount.data.data
    //         ? listAccount.data.data.map((x) => ({
    //               label: x.fullName,
    //               value: x.id
    //           }))
    //         : [];

    // const lstDepartment =
    //     listDepartment && listDepartment.data
    //         ? listDepartment.data.map((x) => ({
    //               label: x.Ten,
    //               value: x.ID
    //           }))
    //         : [];

    // const listDevices = useQuery(['getAllParentQA'], () =>
    //     Get(DEVICE_API.GET_PAGING, null, {
    //         PageIndex: 1,
    //         PageSize: 10000
    //     })
    // );

    // const lstDevice =
    //     listDevices && listDevices.data && listDevices.data.data
    //         ? listDevices.data.data.$values
    //               .filter((s) => s.id != deviceId)
    //               .map((x) => ({label: x.title, value: x.id}))
    //         : [];

    const diseaseItem = useQuery([diseaseId], () =>
        Get(DISEASE_API.GET_ITEM, diseaseId)
    );

    // const diseaseItem = item;

    // console.log('item', item);

    // const listCate = useQuery(['getAllCate'], () =>
    //     Get(CATEGORY_API.GET_ALL_CATEGORY)
    // );

    const editFunc = useMutation((value) =>
        Put(DISEASE_API.UPDATE_ITEM, diseaseId, value)
    );

    const handleEdit = async (values) => {
        const model = {...values};

        model.id = diseaseId;

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    // onSaved();
                    // queryClient.setQueryData(diseaseId, model);
                    queryClient.invalidateQueries([diseaseId]);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    // const loadOptions = async (inputValue, loadedOptions, {page}) => {
    //     const filteredOptions = lstDepartment
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    // const isLoading = cateItem.isLoading || listCate.isLoading;
    // const isError = cateItem.isError || listCate.isError;
    // const error = cateItem.isError ? cateItem.error : listCate.error;

    const isLoading = diseaseItem.isLoading ? true : false;
    const isError = diseaseItem.isError ? true : false;
    const error = diseaseItem.isError ? diseaseItem.error : null;

    // let menuData = [
    //     {
    //         name: 'Danh mục gốc',
    //         id: 'null',
    //         parentId: NIL_UUID
    //     }
    // ];
    // if (!listCate.isLoading && !listCate.isError) {
    //     menuData = menuData
    //         .concat(listCate.data.data.$values)
    //         .filter((x) => x.id !== cateId);
    // }

    // const loadOptionsAccount = async (inputValue, loadedOptions, {page}) => {
    //     const filteredOptions = lstAccount
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    return (
        <Card>
            <Card.Header as="h5">Xem hoặc sửa giám sát bệnh lý</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Đang tải...</div>
                ) : isError ? (
                    <div>Có lỗi xảy ra: ${error.message}</div>
                ) : diseaseItem == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            name:
                                diseaseItem.data && diseaseItem.data.name
                                    ? diseaseItem.data.name
                                    : '',
                            description:
                                diseaseItem.data && diseaseItem.data.description
                                    ? diseaseItem.data.description
                                    : '',
                            lstAccountPatientId:
                                diseaseItem.data &&
                                diseaseItem.data.accountPatients
                                    ? diseaseItem.data.accountPatients.map(
                                          (x) => x.id
                                      )
                                    : ''
                            // name:
                            //     diseaseItem.name
                            //         ? diseaseItem.name
                            //         : '',
                            // description:
                            //     diseaseItem.description
                            //         ? diseaseItem.description
                            //         : '',
                            // lstAccountPatientId:
                            //     diseaseItem.accountPatients
                            //         ? diseaseItem.accountPatients.map(
                            //               (x) => x.id
                            //           )
                            //         : ''
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Mô tả
                                    </Form.Label>
                                    <Col sm="10">
                                        <Editor
                                            name="description"
                                            value={values.description}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'description',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{span: 10, offset: 2}}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default DiseaseEdit;
